var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTxticon = function SvgTxticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.8 4H1.2a.4.4 0 0 1-.4-.4v-.8c0-.221.18-.4.4-.4h13.6c.22 0 .4.179.4.4v.8a.4.4 0 0 1-.4.4Zm.323 4.4v-.8a.4.4 0 0 0-.4-.4H1.2a.4.4 0 0 0-.4.4v.8c0 .22.18.4.4.4h13.523a.4.4 0 0 0 .4-.4Zm-3.923 4v.8a.4.4 0 0 1-.4.4H1.2a.4.4 0 0 1-.4-.4v-.8c0-.221.18-.4.4-.4h9.6c.22 0 .4.179.4.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgTxticon;